import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import { BlockWeighmentTableContent } from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { CSVLink } from "react-csv";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { BlockWeighmentSchemaObject } from '../BlockWeighmentSchema';
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import _ from 'lodash';
import { saveAs } from 'file-saver';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';

const screenCode = "BLOCKWEIGHTMENTREPORT";

export function BlockWeighmentListing(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [division, setDivision] = useState([]);
    const [field, setField] = useState([]);

    const [isTableHide, setIsTableHide] = useState(true);

    const [blockWeighmentDetails, setBlockWeighmentDetails] = useState({
        groupID: "0",
        estateID: "0",
        date: "",
        divisionID: "0",
        fieldID: "0",
        regNumber: ""
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        estate: "0",
        date: "",
        division: "0",
        field: "0",
        regNumber: ""
    });

    const csvHeaders = [
        { label: "Registration Number", value: "registrationNumber" },
        { label: "Name", value: "nameToBePrinted" },
        { label: "Field Name", value: "fieldName" },
        { label: "Bag Count", value: "numberOfUnits" },
        { label: "Gross Weight", value: "grossAmount" },
        { label: "Total Deduction", value: "totalDeduction" },
        { label: "Net Weight", value: "netAmount" },
        { label: "Total Weight", value: "totalAmount" }
    ];

    const [csvData, setCsvData] = useState([]);
    const [errors, setErrors] = useState({});
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const schema = Joi.object(BlockWeighmentSchemaObject).options({ allowUnknown: true });
    const contentRowNames = ["registrationNumber", "nameToBePrinted", "fieldName", "numberOfUnits",
    "grossAmount", "totalDeduction", "netAmount", "totalAmount"];

    const [reportData, setReportData] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown()
        )
    }, [blockWeighmentDetails.groupID])

    useEffect(() => {
        trackPromise(getDivisionForDropdown())
    }, [blockWeighmentDetails.estateID]);

    useEffect(() => {
        trackPromise(getFieldForDropdown())
    }, [blockWeighmentDetails.divisionID]);

    function handleGroupChange(target) {
        validateInputs(target);

        setBlockWeighmentDetails({
            ...blockWeighmentDetails,
            groupID: target.value,
            estateID: "0",
            date: "",
            divisionID: "0",
            fieldID: "0",
            regNumber: ""
        });
    }

    function handleEstateChange(target) {
        validateInputs(target);

        setBlockWeighmentDetails({
            ...blockWeighmentDetails,
            estateID: target.value,
            date: "",
            divisionID: "0",
            fieldID: "0",
            regNumber: ""
        });
        clearTable();
    }

    function handleToDateChange(target) {
        validateInputs(target);

        setBlockWeighmentDetails({
            ...blockWeighmentDetails,
            date: target.value
        });
        clearTable();
    }

    function handleChangeCommon(target) {
        validateInputs(target);

        setBlockWeighmentDetails({
            ...blockWeighmentDetails,
            [target.name]: target.value
        });
        clearTable();
    }

    function handleChangeDivision(target) {
        validateInputs(target);

        setBlockWeighmentDetails({
            ...blockWeighmentDetails,
            divisionID: target.value,
            fieldID: "0",
            regNumber: ""
        });
        clearTable();
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, BlockWeighmentSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWBLOCKWEIGHTMENTREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setBlockWeighmentDetails({
            ...blockWeighmentDetails,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }

    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const data = await services.getEstatesByGroupID(blockWeighmentDetails.groupID);
        setEstates(data);
    }

    async function getDivisionForDropdown() {
        const data = await services.GetDivisionByEstateID(blockWeighmentDetails.estateID);
        setDivision(data);
    }

    async function getFieldForDropdown() {
        const data = await services.GetFieldsByCollectionPoint(blockWeighmentDetails.divisionID);
        setField(data);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    async function handleSearch(e) {
        e.preventDefault();

        destroyDataTable();
        setIsTableHide(true);

        const errorMessages = validate(schema, blockWeighmentDetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        const result = await services.getReportData(blockWeighmentDetails);

        var mergedArray = [];

        if (result !== null) {
            result.forEach(x => {
                if (mergedArray.length === 0) {
                    mergedArray.push(x);
                } else {
                    var isAvialable = mergedArray.find(y => y.fieldID === x.fieldID && y.registrationNumber === x.registrationNumber);

                    if (isAvialable) {
                        isAvialable.numberOfUnits = parseInt(isAvialable.numberOfUnits) + parseInt(x.numberOfUnits);
                        isAvialable.totalAmount = parseFloat(isAvialable.totalAmount) + parseFloat(x.totalAmount);
                        isAvialable.grossAmount = parseFloat(isAvialable.grossAmount) + parseFloat(x.grossAmount);
                        isAvialable.netAmount = parseFloat(isAvialable.netAmount) + parseFloat(x.netAmount);
                        isAvialable.totalDeduction = parseFloat(isAvialable.totalDeduction) + parseFloat(x.totalDeduction);
                    } else {
                        mergedArray.push(x);
                    }
                }

            });
        }


        setReportData(mergedArray);

        if (mergedArray.length != 0) {
            setIsTableHide(false);
            createDataTable();
            addSelectedSearchValues();
            setCsvData(mergedArray);
        }
    }

    function addSelectedSearchValues() {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[blockWeighmentDetails.groupID],
            estate: estates[blockWeighmentDetails.estateID],
            division: division[blockWeighmentDetails.divisionID],
            field: field[blockWeighmentDetails.fieldID],
            date: blockWeighmentDetails.date,
            regNumber: blockWeighmentDetails.regNumber
        })
    }

    function destroyDataTable() {
        $("#blockWeighment").DataTable().destroy();
    }

    function createDataTable() {
        $('#blockWeighment').DataTable();
    }

    function createFile() {
        var settings = {
            sheetName: 'Block Weighment Report',
            fileName: 'BlockWeighmentReport',
            writeOptions: {}
        }
        var copyOfCsv = _.cloneDeep(csvData)
        var newRow1 = {
            registrationNumber: "Group :" + groups[blockWeighmentDetails.groupID],
            nameToBePrinted: "Estate : " + estates[blockWeighmentDetails.estateID],
            fieldName: "Date : " + blockWeighmentDetails.date
        }
        var newRow2 = {
            registrationNumber: "Division : " + division[blockWeighmentDetails.divisionID],
            nameToBePrinted: "Field : " + field[blockWeighmentDetails.fieldID],
            fieldName: "Registartion Number : " + blockWeighmentDetails.regNumber,
        }
        copyOfCsv.push({}, {}, newRow1)
        copyOfCsv.push(newRow2)
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }


    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setBlockWeighmentDetails({
            ...blockWeighmentDetails,
            date: "",
            division: "0",
            field: "0",
            regNumber: ""
        });
        setIsTableHide(true);
        setErrors("");
    }

    function clearTable() {
        setIsTableHide(true);
        setReportData([]);
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Block Weighment Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                            >
                                <div className="form-group row">
                                    <div className="col-md">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={blockWeighmentDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="estateID">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={blockWeighmentDetails.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="date">Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="date"
                                            name="date"
                                            type="date"
                                            onChange={(e) => handleToDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["date"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["date"]}</FormHelperText>)}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md">
                                        <InputLabel shrink id="divisionID">Division</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={blockWeighmentDetails.divisionID}
                                            onChange={(e) => handleChangeDivision(e.target)}
                                        >
                                            <MenuItem value="0">--All Division--</MenuItem>
                                            {generateDropDownMenu(division)}
                                        </Select>
                                        {errors["divisionID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="fieldID">Field</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="fieldID"
                                            id="fieldID"
                                            name="fieldID"
                                            value={blockWeighmentDetails.fieldID}
                                            onChange={(e) => handleChangeCommon(e.target)}
                                        >
                                            <MenuItem value="0">--All Field--</MenuItem>
                                            {generateDropDownMenu(field)}
                                        </Select>
                                        {errors["fieldID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["fieldID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="toDate">Registartion Number</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="regNumber"
                                            name="regNumber"
                                            type="regNumber"
                                            onChange={(e) => handleChangeCommon(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["regNumber"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["regNumber"]}</FormHelperText>)}
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, blockWeighmentDetails)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>
                            {isTableHide ? null :
                                <div>
                                    <div className="row">
                                        <div className="col-md-12 pt-2 pb-3">
                                            <div className="card p-2">
                                                <div className="table-responsive row-top-gap">
                                                    <table id="blockWeighment" className="display dataTable no-footer">
                                                        <thead>
                                                            <tr>
                                                                <th> Registration Number</th>
                                                                <th> <center>Name</center> </th>
                                                                <th> <center>Field Name</center></th>
                                                                <th> <center>Bag Count</center></th>
                                                                <th> <center>Gross Weight</center></th>
                                                                <th> <center>Total Deduction</center> </th>
                                                                <th> <center>Net Weight</center></th>
                                                                <th> <center>Total Weight</center> </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <BlockWeighmentTableContent
                                                                data={reportData}
                                                                contentRowNames={contentRowNames}
                                                                hasEdit={false}
                                                            />
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pt-2">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />

                                        <ReactToPrint
                                            documentTitle={"Block Weighment Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} reportData={reportData}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
